import { BakcellPageBanner } from '@/icons/index';

import styles from './styles.module.scss';

const PageBanner = ({ title, subtitle, text }) => {
  return (
    <div
      className={styles.banner}
      itemScope
      itemType='https://schema.org/Offer'
    >
      <div className={`wrapper ${styles.wrapper}`}>
        <div className={styles.content}>
          {subtitle && (
            <h2
              className={styles.subtitle}
              dangerouslySetInnerHTML={{ __html: subtitle }}
            />
          )}
          <h2
            className={styles.title}
            dangerouslySetInnerHTML={{ __html: title }}
          />
          {text && <span className={styles.text}>{text}</span>}
        </div>
        <div className={styles.image}>
          <BakcellPageBanner />
        </div>
      </div>
    </div>
  );
};

export default PageBanner;
